import { Route, Redirect } from 'wouter';
import { resolveOnboardingRedirect } from '../onboarding';
import { GuardProps } from './guard.types';

export function OnboardingGuard({ path, component, step }: GuardProps) {
  const redirect = resolveOnboardingRedirect(step);

  if (
    redirect &&
    window.location.pathname !== redirect
  ) {
    return (
      <Route path={path}>
        <Redirect to={redirect} />
      </Route>
    );
  }

  return <Route path={path} component={component} />;
}
